<template>
    <v-dialog
        attach=".demo-wrapper"
        v-model="show_placeholder_dialog"
        max-width="620"
    >
        <v-card>
            <v-card-title class="headline">
                <span class="text-h6 font-weight-regular">{{ placeholder_text }}</span>
            </v-card-title>

            <v-card-actions>
                <v-spacer />
                <v-btn
                    color="primary"
                    @click="show_placeholder_dialog = false"
                >
                    Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'PlaceholderDialog',

    data() {
        return {
            show_placeholder_dialog: false,
            placeholder_text: ''
        };
    },

    methods: {
        show(item, custom_message = null) {
            this.placeholder_text = custom_message || `This will be a link to your ${item} page.`;
            this.show_placeholder_dialog = true;
        }
    }
};
</script>